import styled from 'styled-components/macro';
import { device } from '../../styles/devices';
const iconColor = process.env.REACT_APP_ICONS_COLOR || 'white';

export const IconSectionContainer = styled.div`
  width: 100%;

  padding: 0px 10px 20px 10px;
  display: flex;
  text-align: center;
  flex-direction: column;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  & svg {
    fill: ${iconColor};
    margin: 0 auto;
    font-size: 100px;
  }
  @media ${device.laptop} {
    width: 260px;
  }
`;
